var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"infoModal",attrs:{"modal-class":"info-modal","size":"sm"}},[_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v(_vm._s(_vm.message))])]),_c('template',{slot:"modal-footer"},[_c('b-button',{on:{"click":_vm.hide}},[_vm._v("\n      Close\n    ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }